import { render } from "./article-v1.vue?vue&type=template&id=370ad5b2&scoped=true"
import script from "./article-v1.vue?vue&type=script&lang=js"
export * from "./article-v1.vue?vue&type=script&lang=js"

import "./article-v1.vue?vue&type=style&index=0&id=370ad5b2&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370ad5b2"]])

export default __exports__